var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "adviser-container"
  }, [_c("van-popup", {
    style: {
      background: "#eef6ff",
      width: "calc(100vw - 32px)"
    },
    attrs: {
      round: "",
      closeable: ""
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("div", {
    staticClass: "adviser-title"
  }, [_vm._v("顾问列表")]), _c("div", {
    staticClass: "adviser-list m-b-16"
  }, [_vm._l(_vm.dataList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "adviser-item"
    }, [_c("div", {
      staticClass: "adviser-info"
    }, [_c("van-image", {
      attrs: {
        round: "",
        src: item.avatarPath,
        width: "36px",
        height: "36px"
      }
    }), _c("div", {
      staticClass: "m-l-8"
    }, [_vm._v(_vm._s(item.name))])], 1), _c("div", {
      staticClass: "bind-btn",
      on: {
        click: function click($event) {
          return _vm.bindAdviser(item);
        }
      }
    }, [_vm._v("绑定顾问")])]);
  }), _vm.loading ? _c("van-loading") : _vm._e()], 2)]), _c("van-popup", {
    style: {
      background: "#eef6ff",
      width: "80vw"
    },
    attrs: {
      round: "",
      closeable: ""
    },
    model: {
      value: _vm.visibleInfo,
      callback: function callback($$v) {
        _vm.visibleInfo = $$v;
      },
      expression: "visibleInfo"
    }
  }, [_c("div", {
    staticClass: "adviser-title"
  }, [_vm._v("顾问信息")]), _c("div", {
    staticClass: "adviser-detail-info m-b-16"
  }, [_c("div", {
    staticClass: "adviser-base-info"
  }, [_c("van-image", {
    attrs: {
      src: _vm.adviserInfo.avatarPath,
      round: "",
      width: "64px",
      height: "64px"
    }
  }), _c("div", {
    staticClass: "adviser-name"
  }, [_vm._v(_vm._s(_vm.adviserInfo.name))])], 1), _c("van-image", {
    staticClass: "m-t-36",
    attrs: {
      src: _vm.adviserInfo.qrcodePath
    }
  }), _vm.loading ? _c("van-loading") : _vm._e()], 1)]), _c("div", {
    staticClass: "open-btn",
    on: {
      click: _vm.showPopup
    }
  }, [_vm._v("顾问咨询")])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };